import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { CHECKOUT_URL, OFFER_ANCHOR, PRODUCT_IMAGE } from '../data/constants';
export function FinalCTA() {
  return <section className="grid-texture border-b border-steelLine bg-steel px-4 py-8 sm:py-10" data-id="element-37" data-mp="c70wb5r477mg">
      <div className="mx-auto max-w-2xl text-center" data-id="element-38" data-mp="84xkuh4g4316">
        <h2 className="text-xl text-white sm:text-3xl" data-id="element-39" data-mp="87a1mqygw7cn">
          Spend Less Time Planning. <span className="text-gold" data-id="element-40" data-mp="m33zmexpdcaz">Spend More Time Building.</span>
        </h2>
        <div className="mt-2.5 space-y-1.5 text-sm font-medium leading-snug text-lightGray" data-id="element-41" data-mp="h52ihzju7n25">
          <p data-id="element-42" data-mp="vtqbby2atioe">
            You can keep searching for project ideas, sketching from zero and figuring out every new build from
            scratch.
          </p>
          <p data-id="element-43" data-mp="14v6kk2hdner1">
            Or you can open one organized collection containing 3000+ fabrication projects ready to explore.
          </p>
          <p className="font-semibold text-white" data-id="element-44" data-mp="zxekgl6kwmbr">
            Choose the project. Review the plan. Prepare your materials. Start building.
          </p>
        </div>
        <a href={OFFER_ANCHOR} className="mt-3 block rounded-lg focus:outline-none focus-visible:ring-4 focus-visible:ring-gold/40" data-id="element-45" data-mp="2h3hmeif58m37">
          <img src={PRODUCT_IMAGE} alt="METAL FABRICATION READY™ — 3000+ ready-to-build metal fabrication plans" className="mx-auto w-full max-w-[14rem] rounded-lg shadow-2xl shadow-black/60 sm:max-w-xs" data-id="element-46" data-mp="2m4xakjcmb8pt" />
        </a>
        <h3 className="mt-3 text-base text-gold sm:text-xl" data-id="element-47" data-mp="301k8aocea2ws">🔩 Metal Fabrication Ready™</h3>
        <p className="mt-0.5 font-display text-xs font-bold uppercase tracking-wide text-white sm:text-sm" data-id="element-48" data-mp="34t2blj1w4fkx">
          3000+ Ready-to-Build Metal Fabrication Plans
        </p>
        <p className="mt-1 text-[0.7rem] font-semibold uppercase tracking-wider text-steelGray sm:text-xs" data-id="element-49" data-mp="3errtvcxp821p">
          Plans • Measurements • References • Project Ideas • 5 Bonuses
        </p>
        <p className="mt-2.5 font-display text-sm font-extrabold uppercase tracking-wide text-gold" data-id="element-50" data-mp="1joczyjhcj9z6">
          🔥 Get Instant Access Today
        </p>
        <div className="mx-auto mt-2 max-w-md" data-id="element-51" data-mp="1eqjw3x3ims22">
          <CTAButton href={CHECKOUT_URL} external sub="Immediate Access • Digital Delivery" data-id="element-52" data-mp="1sgnc46bsxpj2">
            Yes! I Want Metal Fabrication Ready™
          </CTAButton>
        </div>
        <p className="mt-2 inline-flex items-center gap-1.5 text-[0.7rem] font-bold text-gold sm:text-xs" data-id="element-53" data-mp="1nnu5te0oq94v">
          <ShieldCheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-54" data-mp="22gnxdxt8efpw" /> 🛡️ 14-Day Money-Back Guarantee
        </p>
      </div>
    </section>;
}